import { DEFAULT_ROLE_TOKEN_HEADER } from "@hg/one-account"

import { auth } from "@/utils/auth"
import request from "@/utils/request"
import { IRogue5GameInfo } from "../types"

interface RSP<T = unknown> {
    code: number
    data: T
    msg: string
}

const TOPIC_ID = "rogue_5"

export const gameSignIn = async (rewardId: string) => {
    return request.post(
        `/api/topic/${TOPIC_ID}/signIn`,
        {
            rewardId,
        },
        {
            headers: {
                [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
            },
        }
    ) as Promise<RSP>
}

export const gameGetInfo = async () => {
    return request.get(`/api/topic/${TOPIC_ID}/info`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    }) as Promise<RSP<IRogue5GameInfo & { characters: string[] }>>
    // return Promise.resolve({
    //     code: 0,
    //     data: {
    //         game: {
    //             complete: true,
    //         },
    //         roll: {
    //             used: true,
    //             awardId: "ticket",
    //         },
    //         signInRecord: [
    //             {
    //                 index: 0,
    //                 rewardId: "GOLD",
    //                 ts: 0,
    //             },
    //         ],
    //     },
    //     msg: "success",
    // })
}

export const gameDraw = async () => {
    return request.post(
        `/api/topic/${TOPIC_ID}/draw`,
        {},
        {
            headers: { [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken() },
        }
    ) as Promise<
        RSP<{
            bingo: boolean
            awardId: string
        }>
    >
    // return Promise.resolve({
    //     code: 0,
    //     data: {
    //         bingo: true,
    //         awardId: "ticket",
    //     },
    //     msg: "success",
    // })
}

export const gameComplete = async () => {
    return request.post(
        `/api/topic/${TOPIC_ID}/game/complete`,
        {},
        {
            headers: { [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken() },
        }
    ) as Promise<RSP>
}

export const gameFillAddress = async (address: IRogue5GameInfo["contact"]) => {
    // return Promise.resolve({
    //     code: 0,
    //     data: {},
    //     msg: "success",
    // })
    return request.post(`/api/topic/${TOPIC_ID}/fill`, address, {
        headers: { [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken() },
    }) as Promise<RSP>
}

export function getSpecialOperator(charId: string): Promise<{
    code: number
    msg: string
    data: {
        charId: string
        skinId: string
        exp: number
        level: number
        evolvePhase: number
        potentialRank: number
        mainSkillLvl: number
        skills: {
            id: string
            specializeLevel: number
        }[]
        defaultSkillId: string
        equip: {
            id: string
            level: number
            hide: boolean
            locked: boolean
            typeIcon: string
        }[]
        defaultEquipId: string | null
        favorPercent: number
        gainTime: number
        sp?: {
            master: Record<string, number>
        }
    } | null
}> {
    return request.get(`/api/special/operator/${charId}`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}

export const accountSignIn = async (sdkuid: string, token: string) => {
    return request.post(`/api/account/login`, {
        sdkuid,
        token,
    }) as Promise<RSP>
}

export const accountSignOut = async () => {
    return request.post(`/api/account/logout`) as Promise<RSP>
}

export const accountSignInfo = async () => {
    return request.get(`/api/account/info`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    }) as Promise<RSP<IRogue5GameInfo & { characters: string[] }>>
}

// qa
export const clearData = async (uid: string) => {
    return request.post(`/api/qa/clear-user-data`, { uid }) as Promise<RSP>
}
export const setSeverTime = async (time: string) => {
    return request.post(`/api/qa/set-server-time`, { time }) as Promise<RSP>
}
export const getSeverTime = async () => {
    return request.get(`/api/qa/get-server-time`) as Promise<RSP>
}
export const resetSeverTime = async () => {
    return request.post(`/api/qa/reset-server-time`) as Promise<RSP>
}
